import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { IFile } from '@shared/model';
import { SnackbarService } from '../snackbar/snackbar.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileComponent <T extends IFile> implements OnInit {
  @Input() multiple: boolean = true;
  /**
   * @name canEdit
   * @description управление режимом добавления и удаления элементов списка файлов
   * @default true
   */
  @Input() canEdit: boolean = true;
  @Input() files: IFile[] | undefined | null = [];
  @Output() onUploadFiles: EventEmitter<FileList> = new EventEmitter<FileList>();
  @Output() onDeleteFile: EventEmitter<number> = new EventEmitter<number>();
  @Output() onDownloadFile: EventEmitter<IFile> = new EventEmitter<IFile>();

  message = 'Перетащите сюда файлы по проекту ';

  constructor(private _snackbarService: SnackbarService) {}

  ngOnInit(): void {
    this.message = 'Перетащите сюда файлы по проекту ';
  }

  onFileDropped(fileList: FileList) {
    this._validateFiles(fileList);
  }

  fileBrowseHandler(target: EventTarget | any) {
    this._validateFiles(target.files);
  }

  private _validateFiles(fileList: FileList) {
    if (this.multiple !== false && this.files!.length + fileList.length >= 5) {
      this._snackbarService.openSnackBar('В общей сложности должно быть не больше 5 файлов');
      return;
    }

    let isMaxSizeFileError = false;

    for (let i = 0; i < fileList.length; i++) {
      if (fileList.item(i) && fileList.item(i)!.size > 5242880) {
        isMaxSizeFileError = true;
      }
    }

    if (isMaxSizeFileError) {
      this._snackbarService.openSnackBar('Размер файла превышает 5Mb');
      return;
    }

    this.onUploadFiles.emit(fileList);
  }

  renderIcon(type: string): string {
    if (!this.canEdit) {
      return 'mtd-icon mtd-icon-paper-clip';
    }
    switch (type) {
      case 'txt':
      case 'doc':
      case 'docx':
      case 'rtf':
        return 'icon-file-text';
      case 'xls':
      case 'xlsx':
        return 'icon-file-excel';
      case 'pdf':
        return 'icon-file-pdf';
      case 'jpg':
      case 'jpeg':
      case 'bmp':
      case 'tiff':
      case 'png':
      case 'gif':
        return 'icon-file-image';
      default:
        return '';
    }
  }
  // TODO: perf - удалить или перенести в утилиту
  renderSize(bytes: number): string {
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  async downloadFile(evemt: Event, item: IFile) {
    event?.preventDefault();
    this.onDownloadFile.emit(item);
  }
}
